module.exports = __webpack_public_path__ + "img/video_poster.a95d9a5f.jpg";